import { Http409Code } from '@/api/model/HttpErrorCodes.model.ts';
import ArrowRightSvg from '@/assets/ArrowRightSvg.svg';
import PensiveRobotSvg from '@/assets/PensiveRobotSvg.svg';
import ButtonWithLoading from '@/components/ButtonWithLoading.comp.tsx';
import DialogDesktop from '@/components/dialog/DialogDesktop.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

export interface QuizExpiredMessageProps {
  errorCode: null | keyof typeof Http409Code;
  handleBack: (event: React.FormEvent) => void;
  hideBackButton?: boolean;
}

const QuizExpiredMessageDesktop: React.FC<QuizExpiredMessageProps> = ({
  errorCode,
  handleBack,
  hideBackButton,
}) => {
  const { t } = useTranslationWithPrefix('views.process.409.' + errorCode);
  return (
    <div className="flex gap-20 mt-20 flex-1 justify-content-center w-full">
      <div className="relative flex flex-col justify-center items-center gap-20">
        <DialogDesktop
          arrow={
            <img
              alt="arrow-down"
              className="absolute -z-10 -right-11 bottom-1/4"
              src={ArrowRightSvg}
            />
          }
          content={t('subMessage')}
          message={t('title')}
        />
        {hideBackButton !== true && (
          <ButtonWithLoading className="align-self-md-center" onClick={handleBack}>
            {t('buttons.back')}
          </ButtonWithLoading>
        )}
      </div>
      <div style={{ maxHeight: '60vh' }}>
        <img
          alt="love-robot"
          className="w-full h-100"
          src={generateNonCachableImageSrc(PensiveRobotSvg)}
        />
      </div>
    </div>
  );
};

export default QuizExpiredMessageDesktop;
